import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Button, Link, Stack, Typography } from '@mui/material';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { PageLayout } from 'components/PageLayout';
import { Helmet } from 'react-helmet';
import { Trans, useTranslation } from 'react-i18next';
import { APPLE_APP_STORE_ID } from '../../constants';
import { getHumanReadableCapacitorPlatform } from '../../shared/utils';

const Content = (): JSX.Element => {
  const { t } = useTranslation();

  const handleClickUpgrade = async (): Promise<void> => {
    await AppUpdate.openAppStore({ appId: APPLE_APP_STORE_ID }); // appId is ignored by Android play store
  };

  return (
    <>
      <Helmet>
        <title>{t('appIsExpired.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{
            flex: 1,
            maxWidth: 275,
            margin: '0 auto',
          }}
        >
          <Typography variant="h3" fontWeight="fontWeightBold">
            {t('appIsExpired.title')}
          </Typography>

          <Typography>
            {t('appIsExpired.description', {
              platform: getHumanReadableCapacitorPlatform(),
            })}
          </Typography>

          <Button size="large" fullWidth onClick={handleClickUpgrade}>
            {t('appIsExpired.button')}
          </Button>

          <Typography variant="body2">
            <Trans i18nKey="appIsExpired.footer">
              If this device is no longer supported, please visit
              <Link
                href="https://app.watchduty.org/"
                target="_blank"
                color="inherit"
                fontWeight="fontWeightBold"
              >
                app.watchduty.org.
              </Link>
            </Trans>
          </Typography>
        </Stack>
      </SimplePageLayout>
    </>
  );
};

export const AppIsExpired = (): JSX.Element => {
  return (
    <PageLayout data-cname="AppIsExpiredPage" data-testid="AppIsExpiredPage">
      <Content />
    </PageLayout>
  );
};
